// source: pbtypes/gen/attachment_manager/port_data_to_consumers.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_accessories_accessory_enum_pb = require('../../../pbtypes/gen/accessories/accessory_enum_pb.js');
goog.object.extend(proto, pbtypes_gen_accessories_accessory_enum_pb);
var pbtypes_gen_attachment_manager_port_state_pb = require('../../../pbtypes/gen/attachment_manager/port_state_pb.js');
goog.object.extend(proto, pbtypes_gen_attachment_manager_port_state_pb);
var pbtypes_gen_housekeeper_insertion_detection_pb = require('../../../pbtypes/gen/housekeeper/insertion_detection_pb.js');
goog.object.extend(proto, pbtypes_gen_housekeeper_insertion_detection_pb);
goog.exportSymbol('proto.attachment_manager.PortDataToConsumers', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment_manager.PortDataToConsumers = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment_manager.PortDataToConsumers, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment_manager.PortDataToConsumers.displayName = 'proto.attachment_manager.PortDataToConsumers';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment_manager.PortDataToConsumers.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment_manager.PortDataToConsumers.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment_manager.PortDataToConsumers} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment_manager.PortDataToConsumers.toObject = function(includeInstance, msg) {
  var f, obj = {
portState: jspb.Message.getFieldWithDefault(msg, 1, 0),
hardwareConnection: jspb.Message.getFieldWithDefault(msg, 5, 0),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
healthy: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
isSpoofed: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment_manager.PortDataToConsumers}
 */
proto.attachment_manager.PortDataToConsumers.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment_manager.PortDataToConsumers;
  return proto.attachment_manager.PortDataToConsumers.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment_manager.PortDataToConsumers} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment_manager.PortDataToConsumers}
 */
proto.attachment_manager.PortDataToConsumers.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.attachment_manager.PortState.Enum} */ (reader.readEnum());
      msg.setPortState(value);
      break;
    case 5:
      var value = /** @type {!proto.housekeeper.InsertionDetection.Enum} */ (reader.readEnum());
      msg.setHardwareConnection(value);
      break;
    case 2:
      var value = /** @type {!proto.accessories.AccessoryEnum.Enum} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHealthy(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSpoofed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment_manager.PortDataToConsumers.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment_manager.PortDataToConsumers.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment_manager.PortDataToConsumers} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment_manager.PortDataToConsumers.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPortState();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getHardwareConnection();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getHealthy();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsSpoofed();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional PortState.Enum port_state = 1;
 * @return {!proto.attachment_manager.PortState.Enum}
 */
proto.attachment_manager.PortDataToConsumers.prototype.getPortState = function() {
  return /** @type {!proto.attachment_manager.PortState.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.attachment_manager.PortState.Enum} value
 * @return {!proto.attachment_manager.PortDataToConsumers} returns this
 */
proto.attachment_manager.PortDataToConsumers.prototype.setPortState = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional housekeeper.InsertionDetection.Enum hardware_connection = 5;
 * @return {!proto.housekeeper.InsertionDetection.Enum}
 */
proto.attachment_manager.PortDataToConsumers.prototype.getHardwareConnection = function() {
  return /** @type {!proto.housekeeper.InsertionDetection.Enum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.housekeeper.InsertionDetection.Enum} value
 * @return {!proto.attachment_manager.PortDataToConsumers} returns this
 */
proto.attachment_manager.PortDataToConsumers.prototype.setHardwareConnection = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional accessories.AccessoryEnum.Enum type = 2;
 * @return {!proto.accessories.AccessoryEnum.Enum}
 */
proto.attachment_manager.PortDataToConsumers.prototype.getType = function() {
  return /** @type {!proto.accessories.AccessoryEnum.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.accessories.AccessoryEnum.Enum} value
 * @return {!proto.attachment_manager.PortDataToConsumers} returns this
 */
proto.attachment_manager.PortDataToConsumers.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional bool healthy = 6;
 * @return {boolean}
 */
proto.attachment_manager.PortDataToConsumers.prototype.getHealthy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment_manager.PortDataToConsumers} returns this
 */
proto.attachment_manager.PortDataToConsumers.prototype.setHealthy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_spoofed = 4;
 * @return {boolean}
 */
proto.attachment_manager.PortDataToConsumers.prototype.getIsSpoofed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment_manager.PortDataToConsumers} returns this
 */
proto.attachment_manager.PortDataToConsumers.prototype.setIsSpoofed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


goog.object.extend(exports, proto.attachment_manager);
